import React from 'react';
import {Totals} from '../../../../../common/components/Totals/Totals';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../../common/constants';

export const SubtotalRow = () => {
  const localeKeys = useLocaleKeys();
  const {cart} = useControllerProps().checkoutStore;
  const {experiments} = useExperiments();
  const taxIncludedInPrice = cart.taxInfo.pricesIncludeTax;

  const getSubtotalRowTitleText = (): string => {
    return taxIncludedInPrice
      ? localeKeys.checkout.order_summary.totals.items()
      : localeKeys.checkout.order_summary.totals.subtotal();
  };
  return (
    <Totals.TotalsRow
      dataHook={TotalsSectionDataHooks.SubtotalRow}
      title={
        experiments.enabled(SPECS.ShowPriceSummaryByTaxIncluded)
          ? localeKeys.checkout.order_summary.totals.subtotal()
          : getSubtotalRowTitleText()
      }
      value={cart.subtotal.formattedAmount}
    />
  );
};
